<template>
  <div class="page-full py-4">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-8">
          <div class="card p-3">
            <div class="card-body">
              <h3 class="text-danger mb-3">
                <b>Ocurrió un problema al realizar el pago.</b>
              </h3>
              <p>
                <b>Error: </b>
                {{ errors[code] || 'Operación Denegada. Intente con otro método de pago.'}}
              </p>
              <p>
                <b>Fecha: </b>
                {{ date }}
              </p>
              <p>
                <b>N° de transacción: </b>
                {{ id }}
              </p>
              <hr />
              <div class="text-center">
                <p>Por favor, inténtalo nuevamente o elije otro método de pago.</p>
                <p>
                  <a :href="`/reserva/${id}`">
                    <b>Intentar de nuevo</b>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const errors = {
  101: 'Operación Denegada. Tarjeta Vencida. Verifique los datos en su tarjeta e ingréselos correctamente.',
  102: 'Operación Denegada. Contactar con entidad emisora de su tarjeta.',
  104: 'Operación Denegada. Operación no permitida para esta tarjeta. Contactar con la entidad emisora de su tarjeta.',
  106: 'Operación Denegada. Intentos de clave secreta excedidos. Contactar con la entidad emisora de su tarjeta.',
  107: 'Operación Denegada. Contactar con la entidad emisora de su tarjeta.',
  108: 'Operación Denegada. Contactar con la entidad emisora de su tarjeta.',
  109: 'Operación Denegada. Contactar con el comercio.',
  110: 'Operación Denegada. Operación no permitida para esta tarjeta. Contactar con la entidad emisora de su tarjeta.',
  111: 'Operación Denegada. Contactar con el comercio.',
  112: 'Operación Denegada. Se requiere clave secreta.',
  116: 'Operación Denegada. Fondos insuficientes. Contactar con entidad emisora de su tarjeta.',
  117: 'Operación Denegada. Clave secreta incorrecta.',
  118: 'Operación Denegada. Tarjeta Inválida. Contactar con entidad emisora de su tarjeta.',
  119: 'Operación Denegada. Intentos de clave secreta excedidos. Contactar con entidad emisora de su tarjeta.',
  121: 'Operación Denegada',
  126: 'Operación Denegada. Clave secreta inválida.',
  129: 'Operación Denegada. Código de seguridad invalido. Contactar con entidad emisora de su tarjeta.',
  180: 'Operación Denegada. Tarjeta Inválida. Contactar con entidad emisora de su tarjeta.',
  181: 'Operación Denegada. Tarjeta con restricciones de débito. Contactar con entidad emisora de su tarjeta.',
  182: 'Operación Denegada. Tarjeta con restricciones de crédito. Contactar con entidad emisora de su tarjeta.',
  183: 'Operación Denegada. Problemas de comunicación. Intente más tarde.',
  190: 'Operación Denegada. Contactar con entidad emisora de su tarjeta.',
  191: 'Operación Denegada. Contactar con entidad emisora de su tarjeta.',
  192: 'Operación Denegada. Contactar con entidad emisora de su tarjeta.',
  199: 'Operación Denegada',

  201: 'Operación Denegada. Tarjeta vencida. Contactar con entidad emisora de su tarjeta.',
  202: 'Operación Denegada. Contactar con entidad emisora de su tarjeta.',
  204: 'Operación Denegada. Operación no permitida para esta tarjeta. Contactar con entidad emisora de su tarjeta.',
  206: 'Operación Denegada. Intentos de clave secreta excedidos. Contactar con la entidad emisora de su tarjeta.',
  207: 'Operación Denegada. Contactar con entidad emisora de su tarjeta.',
  208: 'Operación Denegada. Contactar con entidad emisora de su tarjeta.',
  209: 'Operación Denegada. Contactar con entidad emisora de su tarjeta.',
  263: 'Operación Denegada. Contactar con el comercio.',
  264: 'Operación Denegada. Entidad emisora de la tarjeta no está disponible para realizar la autenticación.',
  265: 'Operación Denegada. Clave secreta del tarjetahabiente incorrecta. Contactar con entidad emisora de su tarjeta.',
  266: 'Operación Denegada. Tarjeta Vencida. Contactar con entidad emisora de su tarjeta.',
  280: 'Operación Denegada. Clave secreta errónea. Contactar con entidad emisora de su tarjeta.',
  290: 'Operación Denegada. Contactar con entidad emisora de su tarjeta.',

  300: 'Operación Denegada. Número de pedido del comercio duplicado. Favor no atender.',
  306: 'Operación Denegada. Contactar con entidad emisora de su tarjeta.',

  401: 'Operación Denegada. Contactar con el comercio.',
  402: 'Operación Denegada.',
  403: 'Operación Denegada. Tarjeta no autenticada.',
  404: 'Operación Denegada. Contactar con el comercio.',
  405: 'Operación Denegada. Contactar con el comercio.',
  406: 'Operación Denegada. Contactar con el comercio.',
  407: 'Operación Denegada. Contactar con el comercio.',
  408: 'Operación Denegada. Código de seguridad no coincide. Contactar con entidad emisora de su tarjeta.',
  409: 'Operación Denegada. Código de seguridad no procesado por la entidad emisora de la tarjeta.',
  410: 'Operación Denegada. Código de seguridad no ingresado.',
  411: 'Operación Denegada. Código de seguridad no procesado por la entidad emisora de la tarjeta.',
  412: 'Operación Denegada. Código de seguridad no procesado por la entidad emisora de la tarjeta.',
  413: 'Operación Denegada. Contactar con entidad emisora de su tarjeta.',
  414: 'Operación Denegada.',
  415: 'Operación Denegada.',
  416: 'Operación Denegada.',
  417: 'Operación Denegada.',
  418: 'Operación Denegada.',
  419: 'Operación Denegada.',
  420: 'Operación Denegada. Tarjeta no es VISA.',
  421: 'Operación Denegada. Contactar con entidad emisora de su tarjeta.',
  422: 'Operación Denegada. El comercio no está configurado para usar este medio de pago. Contactar con el comercio.',
  423: 'Operación Denegada. Se canceló el proceso de pago.',
  424: 'Operación Denegada.',

  666: 'Operación Denegada. Problemas de comunicación. Intente más tarde.',
  667: 'Operación Denegada. Transacción sin respuesta de Verified by Visa.',
  668: 'Operación Denegada. Contactar con el comercio.',
  669: 'Operación Denegada. Contactar con el comercio.',
  670: 'Operación Denegada. Contactar con el comercio.',
  672: 'Operación Denegada. Módulo antifraude.',
  673: 'Operación Denegada. Contactar con el comercio.',
  674: 'Operación Denegada. Contactar con el comercio.',
  675: 'Inicialización de transacción.',
  676: 'Operación Denegada. Contactar con el comercio.',
  677: 'Operación Denegada. Contactar con el comercio.',
  682: 'Operación Denegada. Contactar con el comercio.',
  683: 'Operación Denegada. Operación Denegada.',
  684: 'Operación Denegada Registro Incorrecto Antifraude.',
  685: 'Operación Denegada Registro Incorrecto Autorizador.',

  904: 'Operación Denegada.',
  909: 'Operación Denegada. Problemas de comunicación. Intente más tarde.',
  910: 'Operación Denegada.',
  912: 'Operación Denegada. Entidad emisora de la tarjeta no disponible',
  913: 'Operación Denegada.',
  916: 'Operación Denegada.',
  928: 'Operación Denegada.',
  940: 'Operación Denegada.',
  941: 'Operación Denegada.',
  942: 'Operación Denegada.',
  943: 'Operación Denegada.',
  945: 'Operación Denegada.',
  946: 'Operación Denegada. Operación de anulación en proceso.',
  947: 'Operación Denegada. Problemas de comunicación. Intente más tarde.',
  948: 'Operación Denegada.',
  949: 'Operación Denegada.',
  965: 'Operación Denegada.',
  810: 'Operación Denegada. Usted no puede participar de la Pre venta BBVA, ya que no es cliente del Banco.',

  // Procesos
  '00': 'Aprobado o completado satisfactoriamente',
  '01': 'Consulte con el banco',
  '03': 'Comerciante inválido',
  '04': 'Tarjeta de captura',
  '05': 'Denegado',
  12: 'Transacción inválida',
  13: 'Cantidad no válida',
  14: 'Número de tarjeta inválido',
  15: 'Emisor inválido',
  30: 'Error de formato',
  41: 'Tarjeta perdida',
  43: 'Tarjeta robada',
  45: 'Tarjeta para cuotas',
  51: 'Fondos insuficientes o supero límite máximo de crédito',
  54: 'Tarjeta expirada',
  57: 'Transacción no permitida al emisor/titular de la tarjeta',
  58: 'Transacción no permitida al adquiriente',
  61: 'Excede el límite de cantidad de retiro',
  62: 'Tarjeta restringida',
  63: 'Violación de seguridad',
  65: 'Supera el límite de recuento de retiros',
  76: 'Es inválida o inexistente la cuenta de origen especificada',
  77: 'Es inválida o inexistente la cuenta de destino especificada',
  78: 'Cuenta especificada no válida o inexistente',
  84: 'Ciclo de vida de autorización no válido',
  91: 'Sistema de autorización o sistema emisor inoperativo',
  92: 'No se puede enrutar la transacción',
  94: 'Transacción duplicada detectada',
  96: 'Error del sistema',
  ND: 'Punto-Web Sistema No Disponible',
  PD: 'Punto-Web Permiso Denegado',
  KD: 'Punto-Web Llave Denegada ',
  NR: 'Punto-Web Número de Referencia Inválido',
  NC: 'Punto-Web CVC2 Inválido',
  NE: 'Punto-Web Fecha de Expiración Inválida',
  IM: 'Punto-Web Moneda Inválida',
  FI: 'Punto-Web Fecha Inválida',
  HI: 'Punto-Web Hora Inválida',
  ID: 'Punto-Web Diferido Inválido',
  IC: 'Punto-Web Cuota Inválida',
  IA: 'Punto-Web Monto Inválido',
  CC: 'Punto-Web Tarjeta de Crédito Inválida',
  MC: 'Punto-Web Comercio Inválido',
  SM: 'Punto-Web Secure Code Mensaje (Ver O16)',
  EC: 'Punto-Web Error de Criptografía',
  PC: 'Punto-Web Lo Sentimos por Favor Reintente',
  OV: 'Punto-Web Clave Dinámica SMS Vencida',
  ON: 'Punto-Web Clave Dinámica SMS Incorrecta',
  '': 'Por favor, vuelva a intentar a pagar',
};

export default {
  data() {
    return {
      errors,
      code: '',
      date: '',
      id: '',
    };
  },
  mounted() {
    const { id, code, date } = this.$route.query;
    this.code = code;
    this.date = date;
    this.id = id;
  },
};
</script>
